export default __webpack_public_path__ + "locales/es/Ldap.json?hash=6a025032367c89e9fda12f78e1e8fa51";